import { useQueryWithCallbacks } from '../../hooks/useQueryWithCallbacks';
import axiosInterceptor from '../interceptor/axiosClient';
import { QueryKeys } from '../queryKeys';

interface IPlatformStatusResponse {
  ok: boolean;
  data: {
    message: string;
    expiresAt: string;
  } | null;
}

const getPlatformStatus = async () => {
  const { data } = await axiosInterceptor.get<IPlatformStatusResponse>('/platform-status');
  return data;
};

export const usePollPlatformStatus = () => {
  return useQueryWithCallbacks({
    queryKey: [QueryKeys.getPlatformStatus],
    queryFn: getPlatformStatus,
    refetchInterval: 30_000,
  });
};
